/* artmie-variant-title.js — v1 (2026-09-11)
   The product name on the product page follows the selected variant: "<product title> – <variant label>"
   (one label per option, joined with " / "). The base title is remembered on the <h1> so switching never
   stacks labels. Works on the custom product page (label.custom-pdp-variant-picker__value inputs), also
   after the mobile slider has moved the inputs out of the form, and after the theme morphs the picker
   (it listens to the theme's variant:update event and to input changes). Products with only the default
   variant are left alone. Nothing is written anywhere — display only. */
(function () {
  "use strict";
  if (!/^\/products\//.test(location.pathname)) return;
  /* Claim the flag the old AMH_VTITLE block (formerly appended to
     component-custom-pdp-variant-picker.js) checks, so that if that deploy step ever runs again
     the duplicate stays inert instead of fighting this script over the same h1. */
  if (window.__amhVTitle) return;
  window.__amhVTitle = true;
  var SEP = " – ";
  var DOC0 = null; /* the pristine document.title, captured before we first touch it */
  function h1() { return document.querySelector("h1.custom-pdp-section__title") || document.querySelector(".custom-pdp-section h1") || document.querySelector("main h1"); }
  function selectedLabel() {
    var inputs = document.querySelectorAll("label.custom-pdp-variant-picker__value input:checked");
    if (!inputs.length) return "";
    var byFieldset = [];
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i], v = String(inp.value || "").trim();
      if (!v || /^default title$/i.test(v)) continue;
      byFieldset.push({ f: parseInt(inp.getAttribute("data-fieldset-index") || "0", 10) || 0, v: v });
    }
    byFieldset.sort(function (a, b) { return a.f - b.f; });
    var seen = {}, parts = [];
    for (var j = 0; j < byFieldset.length; j++) { if (seen[byFieldset[j].f]) continue; seen[byFieldset[j].f] = 1; parts.push(byFieldset[j].v); }
    return parts.join(" / ");
  }
  function apply() {
    var el = h1(); if (!el) return;
    var base = el.getAttribute("data-base-title");
    if (base == null) {
      /* The theme morph swaps this h1 for a fresh one and the attribute goes with it. Reading
         textContent back then re-appended the suffix to itself ("- Silver - Silver"). The base is
         stamped server-side now; this fallback only runs on a template that has not been updated
         yet, and it strips a suffix we may already have written before caching. */
      base = el.textContent.trim();
      var already = selectedLabel();
      if (already) {
        var suffix = SEP + already;
        while (base.length > suffix.length && base.slice(-suffix.length) === suffix) base = base.slice(0, -suffix.length).trim();
      }
      el.setAttribute("data-base-title", base);
    }
    /* Stamp the other implementation's attribute with the SAME clean base. If a stale copy of
       AMH_VTITLE is ever present it then computes the same string we do and converges, instead of
       treating our output as its base and compounding the suffix. */
    if (el.getAttribute("data-amh-base") !== base) el.setAttribute("data-amh-base", base);
    var label = selectedLabel();
    var want = label ? base + SEP + label : base;
    if (el.textContent !== want) el.textContent = want;
    /* Always rebuild the tab title from the pristine one. Rebuilding it from the CURRENT title
       appended each new variant to the previous one ("... - Platina - Stribro"). */
    if (DOC0 != null && DOC0.indexOf(base) === 0) {
      var wantDoc = DOC0.replace(base, want);
      if (document.title !== wantDoc) document.title = wantDoc;
    }
  }
  var t = 0; function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }
  /* The custom picker takes the click itself and sets the new selection asynchronously (after its fetch),
     without a change event or an attribute write — so a click is followed by a few delayed re-reads, and
     every URL update (?variant=…) the picker makes is used as a signal too. */
  /* One safety re-read after the picker fetch settles. The old ladder (150/400/800/1500/2600 ms)
     kept rewriting the h1 for 2.6s after every click; with a stable base every re-read computes
     the same string, so the MutationObserver below plus this single check are enough. */
  function burst() { schedule(); setTimeout(apply, 450); }
  function start() {
    DOC0 = document.title;
    apply();
    document.addEventListener("click", function (e) { var el = e.target && e.target.closest ? e.target.closest("label.custom-pdp-variant-picker__value, .artmie-mobile-slider__item") : null; if (el) burst(); }, true);
    document.addEventListener("change", function (e) { if (e.target && e.target.matches && e.target.matches("label.custom-pdp-variant-picker__value input")) burst(); }, true);
    document.addEventListener("variant:update", burst);
    window.addEventListener("popstate", schedule);
    try {
      ["pushState", "replaceState"].forEach(function (fn) { var orig = history[fn]; if (typeof orig !== "function") return; history[fn] = function () { var r = orig.apply(this, arguments); schedule(); return r; }; });
    } catch (_) {}
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["checked", "data-current-checked"] }); } catch (_) {}
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", start, { once: true }) : start();
})();
